import { useGetAccountTree } from "src/api/tree/tree";
import TreeTable from "./tree-table";

const Tree = () => {
  const { data, isLoading, refetch } = useGetAccountTree();

  return (
    <TreeTable
      isLoading={isLoading}
      data={data?.data ?? []}
      refetch={refetch}
    />
  );
};

export default Tree;
